module.exports = __webpack_public_path__ + "img/screenshot.72b73dc9.png";